import { __decorate, __extends, __metadata, __param } from "tslib";
import { BindUserInfoObjectValue } from '../value-object/user-info/bind-user-info';
import { OfficialInfoObjectValue } from '../value-object/user-info/official-info';
import { AccountRepository } from '../../repository/account';
import { Aggregate } from '../../../base/ddd-types/aggregate';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import EnterpriseAccountListEntity from '../entity/account-list/enterprise-account-list';
import { BaseUserInfoObjectValue } from '../value-object/user-info/base-user-info';
import { EnterPriseVipUserInfoObjectValue } from '../value-object/user-info/enterprise-user-info';
var EnterpriseAccountAggregate = /** @class */ (function (_super) {
    __extends(EnterpriseAccountAggregate, _super);
    function EnterpriseAccountAggregate(networkRequestService, tinyId, userInfo) {
        var _this = _super.call(this, tinyId) || this;
        _this.networkRequestService = networkRequestService;
        _this.vipInfo = new EnterPriseVipUserInfoObjectValue();
        _this.bindUserInfo = new BindUserInfoObjectValue();
        _this.officialInfo = new OfficialInfoObjectValue();
        _this.enterpriseAccountListEntity = new EnterpriseAccountListEntity(networkRequestService, tinyId);
        _this.userInfo = new BaseUserInfoObjectValue(userInfo);
        _this.accountRepository = new AccountRepository(networkRequestService);
        return _this;
    }
    EnterpriseAccountAggregate.prototype.completionUserInfo = function (userInfo) {
        if (userInfo.vipInfo) {
            this.vipInfo = new EnterPriseVipUserInfoObjectValue();
        }
        if (userInfo.vip) {
            this.vipInfo.updateVipUserInfo(userInfo.vip);
        }
        if (userInfo.wechatOfficialAccount) {
            this.officialInfo = new OfficialInfoObjectValue(userInfo.wechatOfficialAccount);
        }
        this.bindUserInfo = new BindUserInfoObjectValue(userInfo);
    };
    EnterpriseAccountAggregate = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String, Object])
    ], EnterpriseAccountAggregate);
    return EnterpriseAccountAggregate;
}(Aggregate));
export default EnterpriseAccountAggregate;
